'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckboxStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  textFree: _propTypes2.default.bool,
  theme: _propTypes2.default.object
};

var defaultProps = {
  textFree: false
};

var checkboxSizeProps = function checkboxSizeProps(_ref) {
  var themeFromProvider = _ref.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var size = theme.reactackle.components.checkbox.input.size;
  var _theme$reactackle$com = theme.reactackle.components.checkbox.label,
      fontSize = _theme$reactackle$com.fontSize,
      lineHeight = _theme$reactackle$com.lineHeight;


  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];

  return '\n    min-width: ' + (0, _reactackleCore.getValueString)(size) + ';\n    min-height: ' + (0, _reactackleCore.getValueString)(size) + ';\n    line-height: ' + lineHeight + ';\n    font-size: ' + (0, _reactackleCore.getValueString)(fontSize) + ';\n    \n    &,\n    & *,\n    *::after,\n    *::before {\n      font-family: ' + fontFamily + ';\n      box-sizing: border-box;\n    }    \n  ';
};

var spacing = function spacing(_ref2) {
  var themeFromProvider = _ref2.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var spacing = theme.reactackle.components.checkbox.checkboxesSpacing;


  return '& + & { margin-top: ' + (0, _reactackleCore.getValueString)(spacing) + '; }';
};

var CheckboxStyled = exports.CheckboxStyled = _styledComponents2.default.div.withConfig({
  displayName: 'CheckboxStyled'
})(['position:relative;user-select:none;', ';', ';'], spacing, checkboxSizeProps);

CheckboxStyled.propTypes = propTypes;
CheckboxStyled.defaultProps = defaultProps;
CheckboxStyled.displayName = 'CheckboxStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-checkbox/dist/styles/CheckboxStyled.js
// module id = 617
// module chunks = 0